<template>
	<card>
		<card-header>
			<p class="tw-px-6 tw-py-6 uppercase job-name tw-text-center tw-m-0 text-primary">
				{{ selectedJobPosition.name }}
			</p>
		</card-header>
		<card-sub-header>
			<div class="tw-px-6 tw-py-6">
				<p class=" tw-m-0 text-info tw-text-center">Selecciona los subordinado del puesto de {{ selectedJobPosition.name }}</p>
			</div>
		</card-sub-header>
		<div class="job-children-body tw-py-4">
			<div v-for="(child) in children" class="tw-flex tw-items-center tw-mb-2">
				<check-icon-filled class="tw-mr-2" /> <span class="text-info">{{ child.name }}</span>
			</div>
		</div>
		<card-footer class="tw-text-center tw-pt-5">
			<v-btn class="custom-button" color="primary" @click="$emit('closeClick')">Cerrar</v-btn>
		</card-footer>
	</card>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/Card';
import CardHeader from '@/modules/shared/components/ui/Card/CardHeader';
import CardFooter from '@/modules/shared/components/ui/Card/CardFooter';
import { concat, filter, map, pipe, pluck, propEq, reduce } from 'ramda';
import CheckIconFilled from '@/modules/shared/components/icons/check-icon-filled';
import CardSubHeader from '@/modules/shared/components/ui/Card/CardSubHeader';

export default {
	name: 'hierarchy-children-list-card',
	components: { CardSubHeader, CheckIconFilled, CardFooter, CardHeader, Card },
	props: ['selectedJobPosition', 'hierarchyAssignation'],
	computed: {
		children() {
			const concatAll = reduce(concat, []);
			return pipe(
				pluck('jobPositions'),
				map(jobPositions => filter(propEq('fatherId', this.selectedJobPosition.id), jobPositions)),
				concatAll,
			)(this.hierarchyAssignation);
		},
	},
};
</script>

<style lang='scss' scoped>
.job-name {
	font-weight: bold;
}
.job-children-body {
	min-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/hierarchy/hierarchy-children/hierarchy-children-list-card.vue